import { useEffect, useState } from "react";
import axios from "axios";
import { API, useMusic } from "../App";
import Footer from "../components/Footer";
import StickyNav from "../components/StickyNav";

import {
  HeroSection,
  ThresholdPhrase,
  TestimonialsSection,
  JeinarSection,
  CoconeusesSection,
  FinalCtaSection,
  ConnectionSection,
  ClosingSignature
} from "../components/home";

const Home = () => {
  const { playMusic } = useMusic();
  const [heroMedia, setHeroMedia] = useState([]);
  const [heroPosition] = useState({ x: 50, y: 44 });

  // SEO
  useEffect(() => {
    document.title = "COCON | Espaces de retraites & de transmission";
    const metaDesc = document.querySelector('meta[name="description"]');
    if (metaDesc) metaDesc.setAttribute("content", "COCON propose des retraites initiatiques de transformation en France (Valouse) et à Bali. Accompagnement par Jeinar et ses coconeuses.");
  }, []);

  // Autoplay music
  useEffect(() => {
    const timer = setTimeout(() => { playMusic(); }, 300);
    return () => clearTimeout(timer);
  }, []);

  // Fetch media
  useEffect(() => {
    const fetchMedia = async () => {
      try {
        const response = await axios.get(`${API}/page-media/home`);
        setHeroMedia(response.data.filter(m => m.section === 'hero'));
      } catch (error) {
        console.error("Error fetching media:", error);
      }
    };
    fetchMedia();
  }, []);

  const defaultHeroImage = "https://customer-assets.emergentagent.com/job_72845822-bdab-43b6-9af2-569fb34c085d/artifacts/pggtt3bk_IMG_8614.jpeg";
  const heroImage = heroMedia.length > 0 ? heroMedia[0].url : defaultHeroImage;

  return (
    <div className="min-h-screen bg-[#77574C]">

      <StickyNav
        homeLabel="COCON"
        homePath="/"
        showHome={false}
        triggerRatio={0.6}
        links={[
          { label: 'Le cercle', href: '#coconeuses-home' },
          { label: 'Jeinar', href: '#jeinar-home' },
          { label: 'Témoignages', href: '#temoignages-home' },
        ]}
      />

      {/* 1 — HERO : Le seuil + Deux chemins */}
      <HeroSection heroImage={heroImage} heroPosition={heroPosition} />

      {/* 2 — LE CERCLE : version courte */}
      <CoconeusesSection />

      {/* 3 — JEINAR : version épurée */}
      <JeinarSection />

      {/* 4 — TÉMOIGNAGES : avant l'appel */}
      <TestimonialsSection />

      {/* 5 — L'APPEL FINAL */}
      <FinalCtaSection />

      {/* 6 — CONNEXION : newsletter */}
      <ConnectionSection />

      {/* 7 — SIGNATURE DE FERMETURE (unique instance de "Certains lieux...") */}
      <ClosingSignature />

      <Footer />
    </div>
  );
};

/* ═══ CONSERVATION TEMPORAIRE — ancien ordre des sections ═══
 *
 * 1. HeroSection
 * 2. ThresholdPhrase ("Peut-être que tu n'es pas arrivé·e ici par hasard.")
 * 3. TestimonialsSection
 * 4. ThresholdPhrase ("Il y a des moments où le chemin change...")
 * 5. JeinarSection
 * 6. ThresholdPhrase ("Certains chemins ne se choisissent pas...")
 * 7. CoconeusesSection
 * 8. FinalCtaSection
 * 9. ConnectionSection
 * 10. ClosingSignature
 *
 * Nav links: Témoignages, Jeinar, Le cercle, Connexion
 *
 * ═══ FIN CONSERVATION TEMPORAIRE ═══ */

export default Home;
